<template>
  <v-container fluid>
    <v-card>
      <v-toolbar>
        <v-icon>edit</v-icon>
        <v-toolbar-title class="font-weight-light"
          >&nbsp;Impactos</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              icon
              color="red"
              v-on="on"
              @click="setStatusTareaFrecuente(action)">
              <v-icon v-if="action.esFrecuente">favorite</v-icon>
              <v-icon v-else>favorite_border</v-icon>
            </v-btn>

            <v-btn color="blue darken-1" text @click="guardarFechas()"
              >Guardar Fechas</v-btn
            >
          </template>
          <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>
          <span v-else>Agregar a Tareas Frecuentes</span>
        </v-tooltip>
      </v-toolbar>

      <v-card-text>
        <v-row>
          <v-container>
            <v-card>
              <v-card-title> Respaldatorio </v-card-title>

              <v-card-text>
                <v-row dense>
                  <v-col cols="6" lg="6">
                    <v-text-field
                      v-model="filtros.respaldatorio.fechaDesde"
                      label="Fecha Desde"
                      type="date"
                      prepend-icon="event"></v-text-field>
                  </v-col>
                  <v-col cols="6" lg="6">
                    <v-text-field
                      v-model="filtros.respaldatorio.fechaHasta"
                      label="Fecha Hasta"
                      type="date"
                      prepend-icon="event"></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-card-actions>
                <v-btn
                  dark
                  color="orange"
                  @click="procesarConsultaRespaldatorio()">
                  Generar tabla&nbsp;
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-container>
        </v-row>

        <v-row>
          <v-container>
            <v-card>
              <v-card-title> Sub Diario </v-card-title>

              <v-card-text>
                <v-row dense>
                  <v-col cols="6" lg="6">
                    <v-text-field
                      v-model="filtros.subDiario.fechaDesde"
                      label="Fecha Desde"
                      type="date"
                      prepend-icon="event"></v-text-field>
                  </v-col>
                  <v-col cols="6" lg="6">
                    <v-text-field
                      v-model="filtros.subDiario.fechaHasta"
                      label="Fecha Hasta"
                      type="date"
                      prepend-icon="event"></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-card-actions>
                <v-btn dark color="orange" @click="procesarConsultaSubDiario()">
                  Generar tabla&nbsp;
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-container>
        </v-row>

        <v-row>
          <v-container>
            <v-card>
              <v-card-title> Ingresos Varios </v-card-title>

              <v-card-text>
                <v-row dense>
                  <v-col cols="6" lg="6">
                    <v-text-field
                      v-model="filtros.ingresosVarios.fechaDesde"
                      label="Fecha Desde"
                      type="date"
                      prepend-icon="event"></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-card-actions>
                <v-btn
                  dark
                  color="orange"
                  @click="procesarConsultaIngresosVarios()">
                  Generar tabla&nbsp;
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-container>
        </v-row>

        <v-row>
          <v-container>
            <v-card>
              <v-card-title> Anulaciones </v-card-title>

              <v-card-text>
                <v-row dense>
                  <v-col cols="6" lg="6">
                    <v-text-field
                      v-model="filtros.anulaciones.fechaDesde"
                      label="Fecha Desde"
                      type="date"
                      prepend-icon="event"></v-text-field>
                  </v-col>
                  <v-col cols="6" lg="6">
                    <v-text-field
                      v-model="filtros.anulaciones.fechaHasta"
                      label="Fecha Hasta"
                      type="date"
                      prepend-icon="event"></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-card-actions>
                <v-btn
                  dark
                  color="orange"
                  @click="procesarConsultaAnulaciones()">
                  Generar tabla&nbsp;
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-container>
        </v-row>

        <v-row>
          <v-container>
            <v-card>
              <v-card-title> Consulta Viva Data </v-card-title>

              <v-card-text>
                <v-row dense>
                  <v-col cols="6" lg="6">
                    <v-text-field
                      v-model="filtros.vivaData.fechaDesde"
                      label="Fecha Desde"
                      type="date"
                      prepend-icon="event"></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-card-actions>
                <v-btn dark color="orange" @click="procesarConsultaVivaData()">
                  Generar tabla&nbsp;
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-container>
        </v-row>

        <v-row>
          <v-container>
            <v-card>
              <v-card-title> Acuerdos </v-card-title>

              <v-card-text>
                <v-row dense>
                  <v-col cols="6" lg="6">
                    <v-text-field
                      v-model="filtros.acuerdos.fechaDesde"
                      label="Fecha Desde"
                      type="date"
                      prepend-icon="event"></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-card-actions>
                <v-btn dark color="orange" @click="procesarConsultaAcuerdos()">
                  Generar tabla&nbsp;
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-container>
        </v-row>

        <v-row>
          <v-container>
            <v-card>
              <v-card-title> Tercerizado </v-card-title>

              <v-card-text>
                <v-row dense>
                  <v-col cols="6" lg="6">
                    <v-text-field
                      v-model="filtros.tercerizado.fechaDesde"
                      label="Fecha Desde"
                      type="date"
                      prepend-icon="event"></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-card-actions>
                <v-btn
                  dark
                  color="orange"
                  @click="procesarConsultaTercerizado()">
                  Generar tabla&nbsp;
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-container>
        </v-row>

        <v-row>
          <v-container>
            <v-card>
              <v-card-title> Empleador </v-card-title>

              <v-card-text>
                <v-row dense>
                  <v-col cols="6" lg="6">
                    <v-text-field
                      v-model="filtros.empleador.fechaDesde"
                      label="Fecha Desde"
                      type="date"
                      prepend-icon="event"></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-card-actions>
                <v-btn dark color="orange" @click="procesarConsultaEmpleador()">
                  Generar tabla&nbsp;
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-container>
        </v-row>

        <v-row>
          <v-container>
            <v-card>
              <v-card-title> CBU no Vinculado </v-card-title>

              <v-card-text>
                <v-row dense>
                  <v-col cols="6" lg="6">
                    <v-text-field
                      v-model="filtros.cbuNoVinculado.fechaDesde"
                      label="Fecha Desde"
                      type="date"
                      prepend-icon="event"></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-card-actions>
                <v-btn
                  dark
                  color="orange"
                  @click="procesarConsultaCbuNoVinculado()">
                  Generar tabla&nbsp;
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-container>
        </v-row>

        <v-row>
          <v-container>
            <v-card>
              <v-card-title> TD Base Smarter </v-card-title>

              <v-card-text>
                <v-row dense>
                  <v-col cols="6" lg="6">
                    <v-text-field
                      v-model="filtros.baseSmarter.fechaDesde"
                      label="Fecha Desde"
                      type="date"
                      prepend-icon="event"></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-card-actions>
                <v-btn
                  dark
                  color="orange"
                  @click="procesarConsultaBaseSmarter()">
                  Generar tabla&nbsp;
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-container>
        </v-row>

        <v-row>
          <v-container>
            <v-card>
              <v-card-title> Crudo Anses </v-card-title>

              <v-card-text>
                <v-row dense>
                  <v-col cols="6" lg="6">
                    <v-text-field
                      v-model="filtros.crudoAnses.fechaDesde"
                      label="Fecha Desde"
                      type="date"
                      prepend-icon="event"></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-card-actions>
                <v-btn
                  dark
                  color="orange"
                  @click="procesarConsultaCrudoAnses()">
                  Generar tabla&nbsp;
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-container>
        </v-row>
      </v-card-text>
    </v-card>

    <app-loading :loading="loading"></app-loading>
  </v-container>
</template>

<script>
import { http } from "@/axios";

import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions,
} from "vuex";

export default {
  data() {
    return {
      loading: false,
      // filtros: {
      //   respaldatorio: {
      //     fechaDesde: null,
      //     fechaHasta: null,
      //     separador: ";",
      //   },
      //   subDiario: {
      //     fechaDesde: null,
      //     fechaHasta: null,
      //     separador: ";",
      //   },
      //   ingresosVarios: {
      //     fechaDesde: null,
      //     fechaHasta: null,
      //     separador: ";",
      //   },
      //   anulaciones: {
      //     fechaDesde: null,
      //     fechaHasta: null,
      //     separador: ";",
      //   },
      //   vivaData: {
      //     fechaDesde: null,
      //     fechaHasta: null,
      //     separador: ";",
      //   },
      //   acuerdos: {
      //     fechaDesde: null,
      //     fechaHasta: null,
      //     separador: ";",
      //   },
      //   tercerizado: {
      //     fechaDesde: null,
      //     fechaHasta: null,
      //     separador: ";",
      //   },
      //   empleador: {
      //     fechaDesde: null,
      //     fechaHasta: null,
      //     separador: ";",
      //   },
      //   cbuNoVinculado: {
      //     fechaDesde: null,
      //     fechaHasta: null,
      //     separador: ";",
      //   },
      //   baseSmarter: {
      //     fechaDesde: null,
      //     fechaHasta: null,
      //     separador: ";",
      //   },
      //   crudoAnses: {
      //     fechaDesde: null,
      //     fechaHasta: null,
      //     separador: ";",
      //   },
      // },
      filtros: {},
      fechas: {},
    };
  },
  async created() {
    this.loadFechas();
    alert(this.fechas.respaldatorioDesde.tostring());

    // this.filtros.respaldatorio.fechaDesde =
    //   this.fechas.respaldatorioDesde.format("YYYY-MM-DD");

    // this.filtros.respaldatorio.fechaDesde = this.$moment(new Date()).format(
    //   "YYYY-MM-DD"
    // );

    // this.filtros.respaldatorio.fechaHasta = this.$moment(new Date()).format(
    //   "YYYY-MM-DD"
    // );

    // this.filtros.subDiario.fechaDesde = this.$moment(new Date()).format(
    //   "YYYY-MM-DD"
    // );
    // this.filtros.subDiario.fechaHasta = this.$moment(new Date()).format(
    //   "YYYY-MM-DD"
    // );

    // this.filtros.ingresosVarios.fechaDesde = this.$moment(new Date()).format(
    //   "YYYY-MM-DD"
    // );
    // this.filtros.ingresosVarios.fechaHasta = this.$moment(new Date()).format(
    //   "YYYY-MM-DD"
    // );

    // this.filtros.anulaciones.fechaDesde = this.$moment(new Date()).format(
    //   "YYYY-MM-DD"
    // );
    // this.filtros.anulaciones.fechaHasta = this.$moment(new Date()).format(
    //   "YYYY-MM-DD"
    // );

    // this.filtros.vivaData.fechaDesde = this.$moment(new Date()).format(
    //   "YYYY-MM-DD"
    // );
    // this.filtros.vivaData.fechaHasta = this.$moment(new Date()).format(
    //   "YYYY-MM-DD"
    // );

    // this.filtros.acuerdos.fechaDesde = this.$moment(new Date()).format(
    //   "YYYY-MM-DD"
    // );
    // this.filtros.acuerdos.fechaHasta = this.$moment(new Date()).format(
    //   "YYYY-MM-DD"
    // );

    // this.filtros.tercerizado.fechaDesde = this.$moment(new Date()).format(
    //   "YYYY-MM-DD"
    // );
    // this.filtros.tercerizado.fechaHasta = this.$moment(new Date()).format(
    //   "YYYY-MM-DD"
    // );

    // this.filtros.empleador.fechaDesde = this.$moment(new Date()).format(
    //   "YYYY-MM-DD"
    // );
    // this.filtros.empleador.fechaHasta = this.$moment(new Date()).format(
    //   "YYYY-MM-DD"
    // );

    // this.filtros.cbuNoVinculado.fechaDesde = this.$moment(new Date()).format(
    //   "YYYY-MM-DD"
    // );
    // this.filtros.cbuNoVinculado.fechaHasta = this.$moment(new Date()).format(
    //   "YYYY-MM-DD"
    // );

    // this.filtros.baseSmarter.fechaDesde = this.$moment(new Date()).format(
    //   "YYYY-MM-DD"
    // );
    // this.filtros.baseSmarter.fechaHasta = this.$moment(new Date()).format(
    //   "YYYY-MM-DD"
    // );

    // this.filtros.crudoAnses.fechaDesde = this.$moment(new Date()).format(
    //   "YYYY-MM-DD"
    // );
    // this.filtros.crudoAnses.fechaHasta = this.$moment(new Date()).format(
    //   "YYYY-MM-DD"
    // );

    alert(this.fechas.respaldatorioDesde);

    alert(this.filtros.respaldatorio.fechaDesde);
  },
  computed: {
    ...mapGetters([
      "activeTask",
      "getActionFromLink",
      "user",
      "closeRelatedTasks",
    ]),
    action: function () {
      return this.getActionFromLink(this.$route.path);
    },
  },
  methods: {
    ...mapMutations([
      "setActiveTask",
      "alertClear",
      "alertSuccess",
      "alertWarning",
      "alertError",
      "setReporteActivo",
    ]),
    ...mapActions(["setStatusTareaFrecuente"]),

    inicializarFiltrosDesdeFechas() {
      const mapeo = {
        respaldatorio: ["respaldatorioDesde", "respaldatorioHasta"],
        subDiario: ["subdiarioDesde", "subdiarioHasta"],
        ingresosVarios: ["ingresosVariosDesde", "ingresosVariosHasta"],
        anulaciones: ["anulacionesDesde", "anulacionesHasta"],
        acuerdos: ["acuerdosDesde", "acuerdosHasta"],
        tercerizado: ["tercerizadoDesde", "tercerizadoHasta"],
        empleador: ["empleadorDesde", "empleadorHasta"],
        cbuNoVinculado: ["cbUnoVinculadoDesde", "cbUnoVinculadoHasta"],
        baseSmarter: ["tdBaseSmarterDesde", "tdBaseSmarterHasta"],
        crudoAnses: ["crudoAnsesDesde", "crudoAnsesHasta"],
        vivaData: ["consultaVivaDataDesde", "consultaVivaDataDataHasta"], // Optional if this exists
      };

      const filtros = {};

      for (const key in mapeo) {
        const [desdeKey, hastaKey] = mapeo[key];
        filtros[key] = {
          fechaDesde: this.fechas[desdeKey] || null,
          fechaHasta: this.fechas[hastaKey] || null,
          separador: ";",
        };
      }

      this.filtros = filtros;

      this.filtros.respaldatorio.fechaDesde = this.$moment(
        this.filtros.respaldatorio.fechaDesde
      ).format("YYYY-MM-DD");

      this.filtros.respaldatorio.fechaHasta = this.$moment(
        this.filtros.respaldatorio.fechaHasta
      ).format("YYYY-MM-DD");

      this.filtros.subDiario.fechaDesde = this.$moment(
        this.filtros.subDiario.fechaDesde
      ).format("YYYY-MM-DD");

      this.filtros.subDiario.fechaHasta = this.$moment(
        this.filtros.subDiario.fechaHasta
      ).format("YYYY-MM-DD");

      this.filtros.ingresosVarios.fechaDesde = this.$moment(
        this.filtros.ingresosVarios.fechaDesde
      ).format("YYYY-MM-DD");

      // this.filtros.ingresosVarios.fechaHasta = this.$moment(
      //   new this.filtros.ingresosVarios.fechaHasta()
      // ).format("YYYY-MM-DD");

      this.filtros.anulaciones.fechaDesde = this.$moment(
        this.filtros.anulaciones.fechaDesde
      ).format("YYYY-MM-DD");

      this.filtros.anulaciones.fechaHasta = this.$moment(
        this.filtros.anulaciones.fechaHasta
      ).format("YYYY-MM-DD");

      this.filtros.vivaData.fechaDesde = this.$moment(
        this.filtros.vivaData.fechaDesde
      ).format("YYYY-MM-DD");

      this.filtros.vivaData.fechaHasta = this.$moment(
        this.filtros.vivaData.fechaHasta
      ).format("YYYY-MM-DD");

      this.filtros.acuerdos.fechaDesde = this.$moment(
        this.filtros.acuerdos.fechaDesde
      ).format("YYYY-MM-DD");

      this.filtros.acuerdos.fechaHasta = this.$moment(
        this.filtros.acuerdos.fechaHasta
      ).format("YYYY-MM-DD");

      this.filtros.tercerizado.fechaDesde = this.$moment(
        this.filtros.tercerizado.fechaDesde
      ).format("YYYY-MM-DD");

      this.filtros.tercerizado.fechaHasta = this.$moment(
        this.filtros.tercerizado.fechaHasta
      ).format("YYYY-MM-DD");

      this.filtros.empleador.fechaDesde = this.$moment(
        this.filtros.empleador.fechaDesde
      ).format("YYYY-MM-DD");

      this.filtros.empleador.fechaHasta = this.$moment(
        this.filtros.empleador.fechaHasta
      ).format("YYYY-MM-DD");

      this.filtros.cbuNoVinculado.fechaDesde = this.$moment(
        this.filtros.cbuNoVinculado.fechaDesde
      ).format("YYYY-MM-DD");

      this.filtros.cbuNoVinculado.fechaHasta = this.$moment(
        this.filtros.cbuNoVinculado.fechaHasta
      ).format("YYYY-MM-DD");

      this.filtros.baseSmarter.fechaDesde = this.$moment(
        this.filtros.baseSmarter.fechaDesde
      ).format("YYYY-MM-DD");

      this.filtros.baseSmarter.fechaHasta = this.$moment(
        this.filtros.baseSmarter.fechaHasta
      ).format("YYYY-MM-DD");

      this.filtros.crudoAnses.fechaDesde = this.$moment(
        this.filtros.crudoAnses.fechaDesde
      ).format("YYYY-MM-DD");

      this.filtros.crudoAnses.fechaHasta = this.$moment(
        this.filtros.crudoAnses.fechaHasta
      ).format("YYYY-MM-DD");
    },

    async loadFechas() {
      this.loading = true;
      try {
        var result = await http.get("impactos/getFechasGeneracionImpactos");
        console.log("Carga Fechas");
        console.log(result);

        this.fechas = result;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
      this.inicializarFiltrosDesdeFechas();
    },

    async procesarConsultaRespaldatorio() {
      var self = this;
      console.log("Fecha Desde:", this.filtros.respaldatorio.fechaDesde);
      console.log("Fecha Hasta:", this.filtros.respaldatorio.fechaHasta);
      try {
        self.loading = true;

        await http
          .post(
            "impactos/procesarconsultarespaldatorio",
            JSON.stringify({
              fechaDesde: this.filtros.respaldatorio.fechaDesde,
              fechaHasta: this.filtros.respaldatorio.fechaHasta,
            })
          )
          .then((resp) => {
            console.log(resp);

            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess("Se generó correctamente la tabla.");
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },

    async procesarConsultaSubDiario() {
      var self = this;

      try {
        self.loading = true;

        await http
          .post(
            "impactos/procesarconsultasubdiario",
            JSON.stringify({
              fechaDesde: this.filtros.subDiario.fechaDesde,
              fechaHasta: this.filtros.subDiario.fechaHasta,
            })
          )
          .then((resp) => {
            console.log(resp);

            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess("Se generó correctamente la tabla.");
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },

    async procesarConsultaIngresosVarios() {
      var self = this;

      try {
        self.loading = true;

        await http
          .post(
            "impactos/procesarconsultaingresosvarios",
            JSON.stringify({
              fechaDesde: this.filtros.ingresosVarios.fechaDesde,
              fechaHasta: this.filtros.ingresosVarios.fechaHasta,
            })
          )
          .then((resp) => {
            console.log(resp);

            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess("Se generó correctamente la tabla.");
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },

    async procesarConsultaAnulaciones() {
      var self = this;

      try {
        self.loading = true;

        await http
          .post(
            "impactos/procesarconsultaanulaciones",
            JSON.stringify({
              fechaDesde: this.filtros.anulaciones.fechaDesde,
              fechaHasta: this.filtros.anulaciones.fechaHasta,
            })
          )
          .then((resp) => {
            console.log(resp);

            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess("Se generó correctamente la tabla.");
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },

    async procesarConsultaVivaData() {
      var self = this;

      try {
        self.loading = true;

        await http
          .post(
            "impactos/procesarconsultavivadata",
            JSON.stringify({
              fechaDesde: this.filtros.vivaData.fechaDesde,
              fechaHasta: this.filtros.vivaData.fechaHasta,
            })
          )
          .then((resp) => {
            console.log(resp);

            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess("Se generó correctamente la tabla.");
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },

    async procesarConsultaAcuerdos() {
      var self = this;

      try {
        self.loading = true;

        await http
          .post(
            "impactos/procesarconsultaacuerdos",
            JSON.stringify({
              fechaDesde: this.filtros.acuerdos.fechaDesde,
              fechaHasta: this.filtros.acuerdos.fechaHasta,
            })
          )
          .then((resp) => {
            console.log(resp);

            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess("Se generó correctamente la tabla.");
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },

    async procesarConsultaTercerizado() {
      var self = this;

      try {
        self.loading = true;

        await http
          .post(
            "impactos/procesarconsultatercerizado",
            JSON.stringify({
              fechaDesde: this.filtros.tercerizado.fechaDesde,
              fechaHasta: this.filtros.tercerizado.fechaHasta,
            })
          )
          .then((resp) => {
            console.log(resp);

            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess("Se generó correctamente la tabla.");
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },

    async procesarConsultaEmpleador() {
      var self = this;

      try {
        self.loading = true;

        await http
          .post(
            "impactos/procesarconsultaempleador",
            JSON.stringify({
              fechaDesde: this.filtros.empleador.fechaDesde,
              fechaHasta: this.filtros.empleador.fechaHasta,
            })
          )
          .then((resp) => {
            console.log(resp);

            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess("Se generó correctamente la tabla.");
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },

    async procesarConsultaCbuNoVinculado() {
      var self = this;

      try {
        self.loading = true;

        await http
          .post(
            "impactos/procesarconsultacbunovinculado",
            JSON.stringify({
              fechaDesde: this.filtros.cbuNoVinculado.fechaDesde,
              fechaHasta: this.filtros.cbuNoVinculado.fechaHasta,
            })
          )
          .then((resp) => {
            console.log(resp);

            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess("Se generó correctamente la tabla.");
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },

    async procesarConsultaBaseSmarter() {
      var self = this;

      try {
        self.loading = true;

        await http
          .post(
            "impactos/procesarconsultabasesmarter",
            JSON.stringify({
              fechaDesde: this.filtros.baseSmarter.fechaDesde,
              fechaHasta: this.filtros.baseSmarter.fechaHasta,
            })
          )
          .then((resp) => {
            console.log(resp);

            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess("Se generó correctamente la tabla.");
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },

    async procesarConsultaCrudoAnses() {
      var self = this;

      try {
        self.loading = true;

        await http
          .post(
            "impactos/procesarconsultacrudoanses",
            JSON.stringify({
              fechaDesde: this.filtros.crudoAnses.fechaDesde,
              fechaHasta: this.filtros.crudoAnses.fechaHasta,
            })
          )
          .then((resp) => {
            console.log(resp);

            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess("Se generó correctamente la tabla.");
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },

    async guardarFechas() {
      var self = this;

      try {
        self.loading = true;

        //    alert(this.filtros.CrudoAndesDesde.fechaDesde);
        await http
          .post(
            "impactos/persistirFechasGeneracionImpactos",
            JSON.stringify({
              RespaldatorioDesde: this.filtros.respaldatorio.fechaDesde,
              RespaldatorioHasta: this.filtros.respaldatorio.fechaHasta,
              SubdiarioDesde: this.filtros.subDiario.fechaDesde,
              SubdiarioHasta: this.filtros.subDiario.fechaHasta,
              IngresosVariosDesde: this.filtros.ingresosVarios.fechaDesde,
              IngresosVariosHasta: this.filtros.ingresosVarios.fechaHasta,
              AnulacionesDesde: this.filtros.anulaciones.fechaDesde,
              AnulacionesHasta: this.filtros.anulaciones.fechaHasta,
              ConsultaVivaDataDesde: this.filtros.vivaData.fechaDesde,
              AcuerdosDesde: this.filtros.acuerdos.fechaDesde,
              TercerizadoDesde: this.filtros.tercerizado.fechaDesde,
              EmpleadorDesde: this.filtros.empleador.fechaDesde,
              CBUnoVinculadoDesde: this.filtros.cbuNoVinculado.fechaDesde,
              TDBaseSmarterDesde: this.filtros.baseSmarter.fechaDesde,
              CrudoAnsesDesde: this.filtros.crudoAnses.fechaDesde,
            })
          )
          .then((resp) => {
            console.log(resp);

            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess("Las fechas han sido guardadas.");
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },
  },
};
</script>
